import { TopSellersMobileDialogProps } from '@/types/props/components';
import { ImagesHeaderCloseSvg } from '@/assets/images_header.assets';
import DefaultButton from '@/components/common/default/DefaultButton';
import translationFallback from '@/utilites/translations/translationFallback';
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import clsx from 'clsx';
import Image from 'next/image';
import { Fragment } from 'react';
import { useTranslation } from 'next-i18next';

export default function TopSellersMobileDialog({
  show,
  onClose,
  generateSkuCard,
  topSellers,
}: TopSellersMobileDialogProps) {
  const { t: tCommon } = useTranslation('common');

  return (
    <Transition appear show={show} as={Fragment} unmount={false}>
      <Dialog
        as="div"
        className="tw-relative tw-z-[9999] max-nine:tw-p-2"
        onClose={onClose}
        unmount={false}
      >
        <div className="tw-fixed tw-h-screen tw-w-screen tw-top-0 tw-left-0 tw-flex tw-items-center tw-justify-center tw-overflow-y-scroll tw-bg-white">
          <TransitionChild
            as={Fragment}
            enter="tw-ease-out tw-duration-300"
            enterFrom="tw-opacity-0 tw-scale-95"
            enterTo="tw-opacity-100 tw-scale-100"
            leave="tw-ease-in tw-duration-200"
            leaveFrom="tw-opacity-100 tw-scale-100"
            leaveTo="tw-opacity-0 tw-scale-95"
            unmount={false}
          >
            <DialogPanel className={clsx('tw-h-full tw-bg-white tw-w-full')}>
              <div className="tw-flex tw-flex-col tw-w-full tw-h-fit tw-y-6">
                <div className="tw-sticky tw-top-0 tw-left-0 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-platinum-gray tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-pb-4 tw-py-5 tw-bg-white tw-z-50">
                  <DefaultButton
                    onClick={() => onClose()}
                    className="tw-absolute tw-left-0 tw--translate-y-1/2 tw-top-8 tw-px-6"
                  >
                    <Image
                      src={ImagesHeaderCloseSvg}
                      alt="close"
                      width={24}
                      height={24}
                    />
                  </DefaultButton>

                  <p className="tw-p-0 tw-m-0 tw-font-plusJakartaSans tw-font-semibold tw-leading-[20.16px] tw-text-base tw-text-center tw-text-textBlack">
                    Top Sellers
                  </p>
                </div>
                <div className="tw-pt-8 tw-px-3">
                  <div className="tw-flex tw-flex-col">
                    <div className="tw-flex tw-items-center tw-justify-between tw-text-gray-500 tw-font-bold tw-w-full tw-pb-1 tw-mt-0 tw-mr-0 tw-mb-[0.8rem] tw-ml-0 tw-border-[#5F6D7E4D] tw-border-solid tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-border-0.75">
                      <span className="tw-text-[#9FA7B2] tw-uppercase tw-font-plusJakartaSans tw-font-semibold tw-text-xs tw-leading-[15.12px]">
                        {' '}
                        {translationFallback(
                          'name',
                          tCommon('name'),
                          'NAME'
                        ).toUpperCase()}
                      </span>
                      <span className="tw-text-[#9FA7B2] tw-uppercase tw-font-plusJakartaSans tw-font-semibold tw-text-xs tw-leading-[15.12px]">
                        {translationFallback(
                          'action',
                          tCommon('action'),
                          'ACTION'
                        ).toUpperCase()}
                      </span>
                    </div>
                    <div className="tw-relative">
                      <div className="tw-flex tw-flex-col tw-w-full tw-gap-[1rem] child:tw-w-full child:tw-flex child:tw-items-center child:tw-justify-between child:tw-text-black child:tw-no-underline child:tw-gap-[1rem]">
                        {topSellers.map(generateSkuCard)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
